// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"204":"31cf456f","210":"99c93a7a","488":"b4ff14b4","992":"02199218"}[chunkId] + ".chunk.css";
};